import React from "react";
import SelectLogoWidget from "@widgets/select-logo";
import TextGroupWidget from "@widgets/text-group";
import ItemSummaryWithPhotoWidget from "@widgets/item-summary-with-photo";
import CheckPointsWidget from "@widgets/check-points";
import TermsConditions from "@widgets/terms-conditions";
import ItemShortSummary from "@widgets/item-short-summary";
import ProgressBar from "@widgets/progress-bar";
import Seperator from "@ui/seperator";
import MessageBox from "@widgets/message-box";
import ComplexTextWidget from "@widgets/complex-text";
import CtaWidget from "@widgets/cta";
import TrackingWidget from "@widgets/tracking";
import TopNavBar from "@widgets/top-nav-bar";
import ItemStatusCard from "@widgets/item-status-card";
import StatusSignWidget from "@widgets/status-sign";
import CarouselWidget from "@widgets/carousel";
import ListTextsWidget from "../list-texts";
import PageActionGroup from "@widgets/page-action-group";
import HelpChatTel from "@widgets/help-chat-tel";
import TwoColumnsData from "@widgets/two-columns-data";
import CompositeWidget from "@widgets/composite-widget";
import TabularDataWidget from "@widgets/tabular-data";
import Collapsible from "@widgets/collapsible";
import ImageBlock, { ImageBlockContain } from "@widgets/image-block";
import WidgetBox from "@widgets/widget-box";
import FormLoanRequirements from "@widgets/app/form-loan-requirements";
import FormPersonalDetails from "@widgets/app/form-personal-details";
import FormLivingSituation from "@widgets/app/form-living-situation";
import FormEmploymentDetails from "@widgets/app/form-employment-details";
import FormPreEnquiryPersonalDetails from "@widgets/app/form-pre-enquiry-personal-details";
import FormLoanReview from "@widgets/app/form-loan-review";
import FormLoanType from "@widgets/app/form-loan-type";
import FormConfirmationChoice from '@widgets/app/form-confirmation-choice';
import ModalWidget from "@widgets/modal";
import FormLoanDetails from "../app/form-loan-details";
import LoanMatchesLoader from "../app/loan-matches-loader";
import FormLoanPreferences from "../app/form-loan-preferences";
import TrustpilotRating from "../app/trustpilot-rating";
import Divider from "@ui/divider";
import PostEnquiryLandingNoInput from "../app/post-enquiry-landing-no-input";
const widgets = {
    // -- GENERIC WIDGETS
    tracking: (widget) => <TrackingWidget data={widget.data} />,
    "cs-with-select-logo": (widget) => <SelectLogoWidget data={widget.data} />,
    "text-group": (widget) => <TextGroupWidget data={widget.data} />,
    "item-summary-with-photo": (widget) => (
        <ItemSummaryWithPhotoWidget data={widget.data} />
    ),
    "check-points": (widget) => (
        <CheckPointsWidget data={widget.data} />
    ),
    "terms-conditions": (widget) => <TermsConditions data={widget.data} />,
    carousel: (widget) => <CarouselWidget data={widget.data} />,
    "item-short-summary": (widget) => <ItemShortSummary data={widget.data} />,
    seperator: (widget) => <Seperator data={widget.data} />,
    progress: (widget) => <ProgressBar data={widget.data} />,
    "message-box": (widget) => <MessageBox data={widget.data} />,
    "toggle-panel": (widget) => <TogglePanelWidget data={widget.data} />,
    "options-panel": (widget) => <OptionsPanelWidget data={widget.data} />,
    "complex-text": (widget) => <ComplexTextWidget data={widget.data} />,
    "reservation-steps": (widget) => <ReservationSteps data={widget.data} />,
    cta: (widget) => <CtaWidget data={widget.data} />,
    "top-nav-bar": (widget) => <TopNavBar data={widget.data} />,
    "status-sign": (widget) => <StatusSignWidget data={widget.data} />,
    "item-status-card": (widget) => <ItemStatusCard data={widget.data} />,
    "list-texts": (widget) => <ListTextsWidget data={widget.data} />,
    "page-action-group": (widget) => <PageActionGroup data={widget.data} />,
    "help-chat-tel": (widget) => <HelpChatTel data={widget.data} />,
    "two-columns-rows": (widget) => <TwoColumnsData data={widget.data} />,
    "composite-widget": (widget) => <CompositeWidget data={widget.data} />,
    "tabular-data": (widget) => <TabularDataWidget data={widget.data} />,
    collapsible: (widget) => <Collapsible data={widget.data} />,
    "image-block": (widget) => <ImageBlock data={widget.data} />,
    "image-block-contain": (widget) => <ImageBlockContain data={widget.data} />,
    "modal": (widget) => <ModalWidget data={widget.data} />,
    "widget-box": (widget) => <WidgetBox data={widget.data} />,
    // -- APPLICATION SPECIFIC WIDGETS

    "form-loan-details": (widget) => (
        <FormLoanDetails data={widget.data} />
    ),
    "form-loan-requirements": (widget) => (
        <FormLoanRequirements data={widget.data} />
    ),
    "form-personal-details": (widget) => (
        <FormPersonalDetails data={widget.data} />
    ),
    "form-living-situation": (widget) => (
        <FormLivingSituation data={widget.data} />
    ),
    "form-employment-details": (widget) => (
        <FormEmploymentDetails data={widget.data} />
    ),
    "form-pre-enquiry-personal-details": (widget) => (
        <FormPreEnquiryPersonalDetails data={widget.data}/>
    ),    
    "form-loan-review": (widget) => <FormLoanReview data={widget.data} />,
    "form-loan-type": (widget) => <FormLoanType data={widget.data} />,
    'form-confirmation-choice': (widget) => (
        <FormConfirmationChoice data={widget.data} />
    ),
    'loan-matches-loader': (widget) => (
        <LoanMatchesLoader data={widget.data} />
    ),
    'trustpilot-rating': (widget) => (
        <TrustpilotRating data={widget.data}/>
    ),
    'form-loan-preferences': (widget) => (
        <FormLoanPreferences data={widget.data}/>
    ),
    'divider': () => (
        <Divider/>
    ),
    'post-enquiry-landing-no-input': (widget) => (
        <PostEnquiryLandingNoInput data={widget.data}/>
    )
};
const PickWidget = ({ widget }) => {
    var cmp = widgets[widget.type];
    if (cmp) return cmp(widget);
    console.error(`No widgets found for type ${widget.type}`);
    return null;
};
export default PickWidget;
